'use client';

import { createContext, useContext, ReactNode } from 'react';

interface TenantContextType {
  selectedTenantId: number | null;
  setSelectedTenantId: (id: number) => void;
  isHydrated: boolean;
}

const TenantContext = createContext<TenantContextType | undefined>(undefined);

/**
 * Simplified tenant context for bid_sourcing_db.
 * Uses a default tenant ID of 1.
 */
export function TenantProvider({ children }: { children: ReactNode }) {
  // For bid_sourcing_db, use a default tenant ID of 1
  const selectedTenantId = 1;
  const isHydrated = true;

  const handleSetTenantId = (id: number) => {
    // No-op for now - bid_sourcing_db doesn't have multi-tenant switching
    console.log('Tenant ID change requested:', id);
  };

  return (
    <TenantContext.Provider value={{ selectedTenantId, setSelectedTenantId: handleSetTenantId, isHydrated }}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() {
  const context = useContext(TenantContext);
  if (context === undefined) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
}
